import React, { Component } from 'react';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'
import Footer from '../components/Footer'

import '../css/ContactUsPage.css';


class ContactUsPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      lang: this.props.lang,
      title: {"en": "Contact Us", "zh": "聯絡我們", "ja": "お問い合わせ"},
      location: {
        "en": {
          "title": "Location",
          "content": [{"addr": "6F-2, No. 31, Huanke 1st Rd., Zhubei City, Hsinchu County 302, Taiwan (R.O.C.)"}]
        },
        "zh": {
          "title": "地點",
          "content": [{"addr": "302新竹縣竹北市環科一路31號6樓之二"}]
        },
        "ja": {
          "title": "所在地",
          "content": [{"addr": "台湾新竹県竹北市環科一路31号6F-2"}]
        }
      },
      email: {
        "en": { "title": "Email", "content": [
          { addr: "contact@nexuni.com", note: "General inquiries" },
          { addr: "parking@nexuni.com", note: "Parking-related questions" }
        ]},
        "zh": { "title": "信箱", "content": [
          { addr: "contact@nexuni.com", note: "一般詢問" },
          { addr: "parking@nexuni.com", note: "停車相關問題" }
        ]},
        "ja": { "title": "メール", "content": [
          { addr: "contact@nexuni.com", note: "一般的なお問い合わせ" },
          { addr: "parking@nexuni.com", note: "駐車場に関するご質問" }
        ]}
      },
      tele: {
        "en": { "title": "Customer Service", "content": ["+886-3-555-1566"] },
        "zh": { "title": "聯絡電話", "content": ["+886-3-555-1566"] },
        "ja": { "title": "カスタマーサービス", "content": ["+886-3-555-1566"] }
      },
      // Form state
      formData: {
        name: '', company: '', email: '', phone: '', country: '', interest: '', message: ''
      },
      formStatus: null, // null, 'sending', 'success', 'error'
      formLabels: {
        en: { name: "Name", company: "Company", email: "Email", phone: "Phone", country: "Country", interest: "Interest", message: "Message", send: "Send Message", success: "Message sent successfully!", error: "Failed to send. Please try email instead.", sending: "Sending...", required: "Required",
              interests: ["Parking Solutions", "Robot Solutions", "Facility Management", "Custom Automation", "Other"] },
        zh: { name: "姓名", company: "公司", email: "信箱", phone: "電話", country: "國家", interest: "感興趣的項目", message: "訊息", send: "送出訊息", success: "訊息已成功送出！", error: "送出失敗，請改用 Email 聯繫。", sending: "送出中...", required: "必填",
              interests: ["停車解決方案", "機器人解決方案", "設施管理", "客製化自動化", "其他"] },
        ja: { name: "お名前", company: "会社名", email: "メール", phone: "電話番号", country: "国", interest: "興味のある分野", message: "メッセージ", send: "送信", success: "メッセージが正常に送信されました！", error: "送信に失敗しました。メールでお問い合わせください。", sending: "送信中...", required: "必須",
              interests: ["駐車ソリューション", "ロボットソリューション", "施設管理", "カスタム自動化", "その他"] }
      }
    }

    this.update_lang = this.update_lang.bind(this)
    this.navigate = this.navigate.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    updateSEO('contact', this.state.lang, '/' + this.state.lang + '/contact');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  handleChange(e) {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value }
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const fd = this.state.formData;
    const subject = encodeURIComponent(
      fd.interest ? `[${fd.interest}] Inquiry from ${fd.name}` : `Inquiry from ${fd.name}`
    );
    const bodyParts = [];
    if (fd.name) bodyParts.push(`Name: ${fd.name}`);
    if (fd.company) bodyParts.push(`Company: ${fd.company}`);
    if (fd.email) bodyParts.push(`Email: ${fd.email}`);
    if (fd.phone) bodyParts.push(`Phone: ${fd.phone}`);
    if (fd.country) bodyParts.push(`Country: ${fd.country}`);
    if (fd.interest) bodyParts.push(`Interest: ${fd.interest}`);
    if (fd.message) bodyParts.push(`\n${fd.message}`);
    const body = encodeURIComponent(bodyParts.join('\n'));
    window.location.href = `mailto:contact@nexuni.com?subject=${subject}&body=${body}`;
  }


  render() {
    const lang = this.state.lang;
    const labels = this.state.formLabels[lang];
    const fd = this.state.formData;

        return (
            <div className={"contact_page " + lang}>
              <AnnouncementBanner lang={lang} />
              <Navbar lang={lang} updateLangFunc={this.update_lang} />
              <Breadcrumb lang={lang} items={[{ label: { zh: "聯絡我們", en: "Contact Us", ja: "お問い合わせ" } }]} />

              <div className="v2_contact_layout">
                <div className="v2_contact_info_side">
                  <h1 className="v2_contact_us_title">{this.state.title[lang]}</h1>

                  <div className="v2_contact_info_group">
                    <h3 className="v2_contact_info_label">{this.state.location[lang].title}</h3>
                    {this.state.location[lang].content.map((item, idx) =>
                      <div key={idx} className="v2_contact_info_item">
                        {item.title && <strong>{item.title}</strong>}
                        <p>{item.addr}</p>
                      </div>
                    )}
                  </div>

                  <div className="v2_contact_info_group">
                    <h3 className="v2_contact_info_label">{this.state.email[lang].title}</h3>
                    {this.state.email[lang].content.map((email, idx) =>
                      <div key={idx} className="v2_contact_email_item">
                        <a href={'mailto:' + email.addr} className="v2_contact_email_link">{email.addr}</a>
                        <span className="v2_contact_email_note">{email.note}</span>
                      </div>
                    )}
                  </div>

                  <div className="v2_contact_info_group">
                    <h3 className="v2_contact_info_label">{this.state.tele[lang].title}</h3>
                    {this.state.tele[lang].content.map((tel, idx) =>
                      <p key={idx}>{tel}</p>
                    )}
                  </div>
                </div>

                <div className="v2_contact_form_side">
                  <form className="v2_contact_form" onSubmit={this.handleSubmit}>
                    <div className="v2_form_row">
                      <div className="v2_form_field">
                        <label>{labels.name} *</label>
                        <input type="text" name="name" value={fd.name} onChange={this.handleChange} required />
                      </div>
                      <div className="v2_form_field">
                        <label>{labels.company} *</label>
                        <input type="text" name="company" value={fd.company} onChange={this.handleChange} required />
                      </div>
                    </div>
                    <div className="v2_form_row">
                      <div className="v2_form_field">
                        <label>{labels.email} *</label>
                        <input type="email" name="email" value={fd.email} onChange={this.handleChange} required />
                      </div>
                      <div className="v2_form_field">
                        <label>{labels.phone}</label>
                        <input type="tel" name="phone" value={fd.phone} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div className="v2_form_row">
                      <div className="v2_form_field">
                        <label>{labels.country}</label>
                        <input type="text" name="country" value={fd.country} onChange={this.handleChange} />
                      </div>
                      <div className="v2_form_field">
                        <label>{labels.interest}</label>
                        <select name="interest" value={fd.interest} onChange={this.handleChange}>
                          <option value="">--</option>
                          {labels.interests.map((opt, idx) =>
                            <option key={idx} value={opt}>{opt}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="v2_form_field v2_form_full">
                      <label>{labels.message}</label>
                      <textarea name="message" rows="5" value={fd.message} onChange={this.handleChange}></textarea>
                    </div>
                    <button type="submit" className="v2_form_submit">
                      {labels.send}
                    </button>
                  </form>
                </div>
              </div>

              <Footer lang={lang} navigate={this.navigate}/>

            </div>

        );}

}
export default ContactUsPage;
